import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/library/icons/interface-award-crown.svg
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 256 256"
};
function render(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", { d: "M248 80a28 28 0 1 0-51.12 15.77l-26.79 33L146 73.4a28 28 0 1 0-36.06 0l-24.03 55.34-26.79-33a28 28 0 1 0-26.6 12L47 194.63A16 16 0 0 0 62.78 208h130.44A16 16 0 0 0 209 194.63l14.47-86.85A28 28 0 0 0 248 80M128 40a12 12 0 1 1-12 12 12 12 0 0 1 12-12M24 80a12 12 0 1 1 12 12 12 12 0 0 1-12-12m169.22 112H62.78l-13.92-83.48L81.79 149a8 8 0 0 0 6.21 3 8 8 0 0 0 1.08-.07 8 8 0 0 0 6.26-4.74l29.3-67.4a27 27 0 0 0 6.72 0l29.3 67.4a8 8 0 0 0 6.26 4.74 8 8 0 0 0 1.08.07 8 8 0 0 0 6.21-3l32.93-40.52ZM220 92a12 12 0 1 1 12-12 12 12 0 0 1-12 12" }, null, -1)])]);
}
var interface_award_crown_default = { render };
//#endregion
export { interface_award_crown_default as default, render };

//# sourceMappingURL=interface-award-crown.svg.js.map